import {
    LogManager
} from './log-manager'
import {
    LogType,
} from '../../common/schemas/enums'
import {
    PageContentParameters,
    PageLookupParameters
} from '../../common/schemas/public'

export class SharedFunctions {
    private logManager: LogManager;

    constructor(logManager: LogManager) {
        this.logManager = logManager;
    }

    debugLog(txt: string | any[], type: LogType | LogType[] = [LogType.CXO]) {
        this.logManager.evaluateDebugLog(txt, type);
    }

    findKey(obj: {[key: string]: any}, keyToFind: string): any {
        if (Array.isArray(obj)) {
        for (const item of obj) {
            const result = this.findKey(item, keyToFind);
            if (result !== undefined) return result;
        }
        } else if (obj !== null && typeof obj === 'object') {
        if (keyToFind in obj) {
            return obj[keyToFind];
        }
        for (const value of Object.values(obj)) {
            const result = this.findKey(value, keyToFind);
            if (result !== undefined) return result;
        }
        }
        return undefined;
    }
    
    removeKeys(obj: {[key: string]: any}, keysToRemove: string[]) {
        if (Array.isArray(obj)) {
        return obj.map(item => this.removeKeys(item, keysToRemove));
        } else if (obj !== null && typeof obj === 'object') {
        return Object.entries(obj).reduce((acc, [key, value]) => {
            if (!keysToRemove.includes(key)) {
            acc[key] = this.removeKeys(value, keysToRemove);
            }
            return acc;
        }, {});
        }
        return obj;
    }

    addWindowEvents(registeredWindowEvents: any){
        const componentContext = this.logManager.componentSource === 'BID_ENRICHMENT' ? ' for Bid Enrichment' : ''; 
        for(var i in registeredWindowEvents){
            this.debugLog(`Adding event ${i} to window${componentContext}`, [LogType.CXO, LogType.QA])
            self.addEventListener(i, registeredWindowEvents[i]);
        }
    }

    removeWindowEvents(registeredWindowEvents: any){
        for(var i in registeredWindowEvents){
          this.debugLog(`Removing event '${i}' from window`, [LogType.CXO, LogType.QA])
          self.removeEventListener(i, registeredWindowEvents[i]);
        }
    }

    generateUniqueId(){
        const ts = Math.round(+new Date() / 1000.0)
        let rand: number;

        try {
            const uu32 = new Uint32Array(1)
            rand = crypto.getRandomValues(uu32)[0]
        } catch (e) {
            rand = Math.round(Math.random() * 2147483647)
        }

        return `CX${rand}X${ts}`;
    }

    filterInvalidCharacters(str: string) {
        // Replace all characters outside the Latin1 range with an empty string
        return str.replace(/[^\x00-\xFF]/g, '');
    }
    
    checkPercentageOutcome(percentageValue) {
        return Boolean((percentageValue ?? 0) > (Math.random()*100));
    }

    getPageContextData(): PageContentParameters {
        const pageData: PageContentParameters = {
          pageUrl: this.filterInvalidCharacters(document.location.href.split('?')[0]),
          title: this.filterInvalidCharacters(document.title),
          text: this.filterInvalidCharacters(Array.from(document.body.querySelectorAll('h1,h2,h3,h4,h5,h6,p,ol')).filter(x => {
            let elementStyle = window.getComputedStyle(x);
            let boundingRect = x.getBoundingClientRect();
            let vis = !(elementStyle.getPropertyValue('display') == 'none'
              || elementStyle.getPropertyValue('visibility') == 'hidden'
              || elementStyle.getPropertyValue('opacity') == '0'
              || boundingRect.width <= 0
              || boundingRect.height <= 0
              || boundingRect.x < 0
              || boundingRect.y < 0);
            return vis;
        }).reduce((acc, elm) => acc.concat(elm.textContent.trim()), []).join(' ').replace(/\r?\n\s{2,}/gi, ' ')).substring(0, 5000),
          meta: Array.from(document.getElementsByTagName('meta')).reduce((acc, curr) => { const attr = curr.attributes; if (attr.length > 1) { acc[curr.attributes[0].value] = this.filterInvalidCharacters(curr.attributes[1].value) } return acc }, {}),
          videos: Array.from(document.getElementsByTagName('video')).reduce((acc, curr) => { const src = curr?.src; if (src != '') { acc.push(src) } return acc }, [])
        }
        return pageData;
    }

    getPageLookupData(): PageLookupParameters {
        const pageData: PageLookupParameters = {
          pageUrl: this.filterInvalidCharacters(document.location.href.split('?')[0])
        }
        return pageData
    }
}
